module.exports = __webpack_public_path__ + "media/images/limit_speed_upload-828c7f95.png";